
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!courses.roster.section";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'courses/roster/section';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  
  return "cannot_remove";
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"ellipsis\" title=\"";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " - "
    + escapeExpression((helper = helpers.enrollmentName || (depth0 && depth0.enrollmentName),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.role), options) : helperMissing.call(depth0, "enrollmentName", (depth0 && depth0.role), options)))
    + "\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " - "
    + escapeExpression((helper = helpers.enrollmentName || (depth0 && depth0.enrollmentName),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.role), options) : helperMissing.call(depth0, "enrollmentName", (depth0 && depth0.role), options)))
    + "</div>\n    <a href=\"#\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'scope': ("courses.roster.section")
  },data:data},helper ? helper.call(depth0, "remove_user_from_course_section", "Remove user from %{name}", options) : helperMissing.call(depth0, "t", "remove_user_from_course_section", "Remove user from %{name}", options)))
    + "\">\n      <i class=\"icon-x\" aria-hidden=\"true\"></i>\n      <span class=\"screenreader-only\">\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'scope': ("courses.roster.section")
  },data:data},helper ? helper.call(depth0, "remove_user_from_course_section", "Remove user from %{name}", options) : helperMissing.call(depth0, "t", "remove_user_from_course_section", "Remove user from %{name}", options)))
    + "\n      </span>\n    </a>\n  ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"ellipsis\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true)
  },data:data},helper ? helper.call(depth0, "you_cannot_remove_this_enrollment_c87be1cb", "You cannot remove this enrollment.", options) : helperMissing.call(depth0, "t", "you_cannot_remove_this_enrollment_c87be1cb", "You cannot remove this enrollment.", options)))
    + "\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + " - "
    + escapeExpression((helper = helpers.enrollmentName || (depth0 && depth0.enrollmentName),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.role), options) : helperMissing.call(depth0, "enrollmentName", (depth0 && depth0.role), options)))
    + "</div>\n  ";
  return buffer;
  }

  buffer += "<li class=\"";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.can_be_removed), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.can_be_removed), {hash:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <input type=\"hidden\" name=\"sections[]\" value=\"section_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n</li>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  